import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AngularDraggableModule } from 'angular2-draggable';

import { RoleGuardService as RoleGuard } from '../providers/authentication/role-guard.service';

import { MapasParentComponent } from '../views/mapas/MapasParent.component';
import { SelectorMapasComponent } from '../views/mapas/SelectorMapas.component';
import { MapasComponent } from '../views/mapas/mapas.component';
import { TranslateModule, TranslateLoader, TranslateStaticLoader  } from 'ng2-translate';

import { PlanoModule } from 'interiores-mapa';
import { Http } from '@angular/http';
import { FormularioAlaComponent } from '../formularios/FormularioAla.component';
import { FormularioConexionComponent } from '../formularios/FormularioConexion.component';
import { FormularioNivelComponent } from '../formularios/FormularioNivel.component';
import { FormularioNodoComponent } from '../formularios/FormularioNodo.component';
import { FormularioSeccionComponent } from '../formularios/FormularioSeccion.component';
import { FormularioCrearSeccionComponent } from '../formularios/FormularioCrearSeccion.component';
import { ColorPickerModule } from 'ngx-color-picker';

import 'hammerjs';


import {
	AccordionModule,
	CalendarModule,
	ConfirmDialogModule,
	DataGridModule,
	DialogModule,
	DropdownModule,
	FileUploadModule,
	GrowlModule,
	InputSwitchModule,
	MessagesModule,
	TabMenuModule,
	PanelModule,
	SlideMenuModule,
	ToolbarModule,
	ListboxModule,
	SliderModule,
	MultiSelectModule
} from 'primeng/primeng';

import { TableModule } from 'primeng/table';
import { FormularioContenidoComponent } from '../formularios/FormularioContenido.component';
import { FormularioBalizaModule } from '../modules/formularios.module';

import { Permisos } from '../providers/authentication/permisos.service';
// import { GeoposicionarComponent } from '../componentes/geoposicionamiento/geoposicionar.component';

export const mapasModuleRoutes: Routes = [
	{
		path: 'mapas',
		component: MapasParentComponent, // the `component` property is necessary when the lazy module provides some service in order to injection work well. If defined, the referenced component's template should have an element with the `<router-outlet>` directive.
		children: [
			{
				path: '',
				component: SelectorMapasComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Mapas_menu]
				},
				pathMatch: 'full'
			},
			{
				path: 'editar',
				component: MapasComponent,
				canActivate: [RoleGuard],
				data: {
					expectedRole: [Permisos.Mapas_menu]
				}
			}
		],
		pathMatch: 'prefix'
	}
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forChild(mapasModuleRoutes),
		FormularioBalizaModule,
		AccordionModule,
		CalendarModule,
		ColorPickerModule,
		ConfirmDialogModule,
		DataGridModule,
		DialogModule,
		DropdownModule,
		FileUploadModule,
		GrowlModule,
		InputSwitchModule,
		ListboxModule,
		PanelModule,
		SlideMenuModule,
		TableModule,
		ToolbarModule,
		TabMenuModule,
		AngularDraggableModule,
		SliderModule,
		PlanoModule,
		MultiSelectModule,
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
        })
		// TableModule,
	],

	declarations: [
		// PlanoComponent,
		MapasParentComponent,
		MapasComponent,
		SelectorMapasComponent,
		FormularioAlaComponent,
		FormularioNivelComponent,
		FormularioConexionComponent,
		FormularioNodoComponent,
		FormularioSeccionComponent,
		FormularioContenidoComponent,
		FormularioCrearSeccionComponent,
		// GeoposicionarComponent

		// SelectorIdiomaComponent
	]

})

export class MapasModule {
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/mapas.module.ts